
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AuthService } from '../../../services/auth.service';

@Component
export default class HeaderToolbar extends Vue {
    get customerLogo(): string | null {
        return this.$store.getters['auth/customerLogo'];
    }

    get customerName(): string {
        const userInfo = this.$store.getters['auth/userInfo'];
        return userInfo && userInfo.customer_name || 'Customer Logo';
    }

    async mounted() {
        // Always refresh user info when authenticated so the customer logo URL
        // stays valid (e.g. signed URLs from backend expire; session may be restored from storage).
        if (this.$store.getters['auth/isAuthenticated']) {
            try {
                const userInfo = await AuthService.getUserInfo();
                this.$store.dispatch('auth/setUserInfo', userInfo);
            } catch (error) {
                console.error('Failed to fetch user info:', error);
                // Keep showing cached logo/name if fetch fails
            }
        }
    }

    handleLogout() {
        this.$store.dispatch('auth/logout');
        this.$router.push('/login');
    }
}
